import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    user: null,
    navMenuItems: [],
  },
  getters: {
    getLoggedInUser: (state) => {
      return state.user;
    },
    hasPermission: (state) => (name) => {
      if (state.user) {
        return state.user.permissions.hasOwnProperty(name);
      }
      return false;
    },
    hasRole: (state) => (name) => {
      if (state.user.role_data.code_name === name) {
        return true;
      }
      return false;
    },
    isLoggedIn: (state) => state.isLoggedIn,
    getNavMenuItems: (state) => state.navMenuItems,
  },
  mutations: {
    login(state, data) {
      state.isLoggedIn = true;
      state.user = data.user;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.user = null;
    },
    setNavMenuItems(state) {
      state.navMenuItems = [];
      if (state.user.permissions.hasOwnProperty("show_dashboard")) {
        state.navMenuItems.push({
          title: "Portfolio",
          icon: "BarChartIcon",
          route: "Dashboard",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_site")) {
        state.navMenuItems.push({
          title: "Sites",
          icon: "MapPinIcon",
          route: "Site",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_building")) {
        state.navMenuItems.push({
          title: "Buildings",
          icon: "BarChart2Icon",
          route: "Building",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_evacuation_diagram")) {
        state.navMenuItems.push({
          title: "Evacuation Diagram",
          icon: "ArrowRightIcon",
          route: "EvacuationDiagram",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_flood_diagram")) {
        state.navMenuItems.push({
          title: "Flood Diagram",
          icon: "ImageIcon",
          route: "FloodDiagram",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_flood_emergency")) {
        state.navMenuItems.push({
          title: "Flood Emergency",
          icon: "DropletIcon",
          route: "FloodEmergency",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_emergency_contact_list")) {
        state.navMenuItems.push({
          title: "ECL",
          icon: "PhoneOutgoingIcon",
          route: "Ecl",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_assembly_area")) {
        state.navMenuItems.push({
          title: "Assembly Area",
          icon: "RssIcon",
          route: "AssemblyArea",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_emergency_scenario_drill")) {
        state.navMenuItems.push({
          title: "Emergency Scenario Drill",
          icon: "AlertTriangleIcon",
          route: "EmergencyScenarioDrill",
        });
      }


      if (state.user.permissions.hasOwnProperty("show_equipment_report")) {
        state.navMenuItems.push({
          title: "Equipment Report",
          icon: "FileTextIcon",
          route: "EquipmentReport",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_qr_code")) {
        state.navMenuItems.push({
          title: "QR Codes",
          icon: "CpuIcon",
          route: "QRCode",
        });
      }

      // if (state.user.permissions.hasOwnProperty("show_device")) {
      //   state.navMenuItems.push({
      //     title: "Devices",
      //     icon: "CodepenIcon",
      //     route: "Device",
      //   });
      // }

      if (state.user.permissions.hasOwnProperty("show_peep")) {
        state.navMenuItems.push({
          title: "PEEPs",
          icon: "CodepenIcon",
          route: "Peep",
        });
      }


      if (state.user.permissions.hasOwnProperty("show_fire_alarm")) {
        state.navMenuItems.push({
          title: "Fire Alarm",
          icon: "BellIcon",
          route: "FireAlarm",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_emergency_drill")) {
        state.navMenuItems.push({
          title: "Emergency Drill",
          icon: "AlertCircleIcon",
          route: "EmergencyDrill",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_user_building")) {
        state.navMenuItems.push({
          title: "Building Activity Log",
          icon: "BellIcon",
          route: "BuildingEmergencyState",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_subscription")) {
        state.navMenuItems.push({
          title: "Email Subscription",
          icon: "ThumbsUpIcon",
          route: "Subscription",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_role")) {
        state.navMenuItems.push({
          title: "Roles",
          icon: "SlidersIcon",
          route: "Role",
        });
      }


      if (state.user.permissions.hasOwnProperty("show_user")) {
        state.navMenuItems.push({
          title: "Users",
          icon: "UsersIcon",
          route: "User",
        });
      }

      // if (state.user.permissions.hasOwnProperty("show_user")) {
      //   state.navMenuItems.push({
      //     title: "Site Approval",
      //     icon: "KeyIcon",
      //     route: "FlatUsers",
      //   });
      // }
    },
  },
  actions: {
    async login({ commit }, payload) {
      const res = await axiosIns.post("login", payload);
      if (res.status === 200) {
        commit("login", res.data);
        commit("setNavMenuItems");
      }
      return res;
    },

    async mobileLogin({ commit }, payload) {
      const res = await axiosIns.post("mobile_login", payload);      
      return res;
    },

    async logout({ commit }) {
      const res = await axiosIns.post("logout");
      if (res.status === 204) {
        commit("logout");
      }
      return res;
    },
    async getCurrentUser({ commit }) {
      const res = await axiosIns.get("current");
      if (res.status === 200) {
        commit("login", res.data);
        commit("setNavMenuItems");
      }
    },
    async getRoles({ commit }, { pageNumber, name }) {
      let url = `roles/?page=${pageNumber}`;
      if (name) {
        url += `&name=${name}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    async getRolesDDL({ commit }) {
      let url = `roles/?page=1`;      
      const res = await axiosIns.get(url);
      return res;
    },
    async getRole({ commit }, { pk }) {
      const res = await axiosIns.get(`roles/${pk}/`);
      return res;
    },
    async createRole({ commit }, payload) {
      const res = await axiosIns.post("roles/", payload);
      return res;
    },
    async updateRole({ commit }, { payload, pk }) {
      const res = await axiosIns.put(`roles/${pk}/`, payload);
      return res;
    },
    async deleteRole({ commit }, { pk }) {
      const res = await axiosIns.delete(`roles/${pk}/`);
      return res;
    },
    async getPermissions({ commit }) {
      const res = await axiosIns.get("permissions");
      return res;
    },
    async getUsers({ commit }, { pageNumber, name, username, role, status, site, building, floor, email }) {
      let url = `users/?page=${pageNumber}`;
      if (name) {
        url += `&name=${name}`;
      }
      if (username) {
        url += `&username=${username}`;
      }
      if (status) {
        url += `&status=${status}`;
      }
      if (role) {
        url += `&role=${role.code_name}`;
      }

      if (site) {
        url += `&site=${site.id}`;
      }

      if (building) {
        url += `&building=${building.id}`;
      }

      if (floor) {
        url += `&floor=${floor.id}`;
      }

      if (email) {
        url += `&email=${email}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    async getUsersDDL({ commit }) {
      let url = `users-unpaginated/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    async getUser({ commit }, { pk }) {
      const res = await axiosIns.get(`users/${pk}/`);
      return res;
    },
    async createUser({ commit }, payload) {
      const res = await axiosIns.post("users/", payload);
      return res;
    },
    async updateUser({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`users/${pk}/`, payload);
      return res;
    },
    async deleteUser({ commit }, { pk }) {
      const res = await axiosIns.delete(`users/${pk}/`);
      return res;
    },



    ////// Sites Functions
    async getSites({ commit }, { pageNumber, name, postcode }) {
      let url = `site/?page=${pageNumber}`;      
      if (name) {
        url += `&name=${name}`;
      }
      if (postcode) {
        url += `&postcode=${postcode}`;
      }
      
      const res = await axiosIns.get(url);
      return res;
    },
    async getSitesDDL({ commit }) {
      let url = `site_ddl/`;            
      const res = await axiosIns.get(url);
      return res;
    },
    async getSite({ commit }, { pk }) {
      const res = await axiosIns.get(`site/${pk}/`);
      return res;
    },
    async createSite({ commit }, payload) {
      const res = await axiosIns.post("site/", payload);
      return res;
    },
    async updateSite({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`site/${pk}/`, payload);
      return res;
    },
    async deleteSite({ commit }, { pk }) {
      const res = await axiosIns.delete(`site/${pk}/`);
      return res;
    },


    ////// Building Functions
    async getBuildings({ commit }, { pageNumber, site, building_type }) {
      let url = `building/?page=${pageNumber}`;      
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building_type) {
        url += `&building_type=${building_type.value}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    async getBuildingsDDL({ commit }) {
      let url = `building_ddl/`;      
      const res = await axiosIns.get(url);
      return res;
    },

    async getBuildingsActiveDDL({ commit }) {
      let url = `building_ddl_active/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getBuilding({ commit }, { pk }) {
      const res = await axiosIns.get(`building/${pk}/`);
      return res;
    },
    async createBuilding({ commit }, payload) {
      const res = await axiosIns.post("building/", payload);
      return res;
    },
    async updateBuilding({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`building/${pk}/`, payload);
      return res;
    },
    async deleteBuilding({ commit }, { pk }) {
      const res = await axiosIns.delete(`building/${pk}/`);
      return res;
    },

    ////// Floor Functions
    async getFloors({ commit }, { pageNumber, building }) {
      let url = `floor/?page=${pageNumber}`;      
      if (building) {
        url += `&building=${building}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    async getFloorsDDL({ commit }) {
      let url = `floor_ddl/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getFloor({ commit }, { pk }) {
      const res = await axiosIns.get(`floor/${pk}/`);
      return res;
    },
    async createFloor({ commit }, payload) {
      const res = await axiosIns.post("floor/", payload);
      return res;
    },
    async updateFloor({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`floor/${pk}/`, payload);
      return res;
    },
    async deleteFloor({ commit }, { pk }) {
      const res = await axiosIns.delete(`floor/${pk}/`);
      return res;
    },



    ////// Flat Functions
    async getFlats({ commit }, { pageNumber, building }) {
      let url = `flat/?page=${pageNumber}`;      
      if (building){
        url += `&building=${building}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    async getFlatsDDL({ commit }) {
      let url = `flat_ddl/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getFlat({ commit }, { pk }) {
      const res = await axiosIns.get(`flat/${pk}/`);
      return res;
    },
    async createFlat({ commit }, payload) {
      const res = await axiosIns.post("flat/", payload);
      return res;
    },
    async updateFlat({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`flat/${pk}/`, payload);
      return res;
    },
    async deleteFlat({ commit }, { pk }) {
      const res = await axiosIns.delete(`flat/${pk}/`);
      return res;
    },

    


    ////// Flat User Functions
    async getFlatUsers({ commit }, { pageNumber, user_type, is_approved, name, building, mobile_number, is_peep, in_building, reached_assembly_area, floor }) {
      let url = `user_flat/?page=${pageNumber}`;      
      if (user_type){
        url += `&user_type=${user_type}`;
      }
      if (is_approved !== undefined){
        url += `&is_approved=${is_approved}`;
      }
      if (name) {
        url += `&name=${name}`;
      }
      if (building) {
        url += `&building=${building}`;
      }
      if (mobile_number) {
        url += `&mobile_number=${mobile_number}`;
      }
      if (is_peep !== undefined) {
        url += `&is_peep=${is_peep}`;
      }
      if (in_building !== undefined) {
        url += `&in_building=${in_building}`;
      }
      if (reached_assembly_area !== undefined) {
        url += `&reached_assembly_area=${reached_assembly_area}`;
      }
      if(floor !== undefined){
        url += `&floor=${floor}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    async getFlatUsersList({ commit }, { pageNumber, user_type, is_approved, name, building, mobile_number, is_peep, in_building, reached_assembly_area }) {
      let url = `user_flat_list/?page=${pageNumber}`;      
      if (user_type){
        url += `&user_type=${user_type}`;
      }
      if (is_approved !== undefined){
        url += `&is_approved=${is_approved}`;
      }
      if (name) {
        url += `&name=${name}`;
      }
      if (building) {
        url += `&building=${building}`;
      }
      if (mobile_number) {
        url += `&mobile_number=${mobile_number}`;
      }
      if (is_peep !== undefined) {
        url += `&is_peep=${is_peep}`;
      }
      if (in_building !== undefined) {
        url += `&in_building=${in_building}`;
      }
      if (reached_assembly_area !== undefined) {
        url += `&reached_assembly_area=${reached_assembly_area}`;
      }
      
      const res = await axiosIns.get(url);
      return res;
    },

        
    async getFlatUser({ commit }, { pk }) {
      const res = await axiosIns.get(`user_flat/${pk}/`);
      return res;
    },
    async createFlatUser({ commit }, payload) {
      const res = await axiosIns.post("user_flat/", payload);
      return res;
    },
    async updateFlatUser({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`user_flat/${pk}/`, payload);
      return res;
    },
    async deleteFlatUser({ commit }, { pk }) {
      const res = await axiosIns.delete(`user_flat/${pk}/`);
      return res;
    },

    



    ////// QR Code Functions
    async getQRCodes({ commit }, { pageNumber, site, building, flat, floor }) {
      let url = `qr_code/?page=${pageNumber}`;      
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building) {
        url += `&building=${building.id}`;
      }
      if (flat) {
        url += `&flat=${flat.id}`;
      }
      if (floor) {
        url += `&floor=${floor.id}`;
      }
      
      const res = await axiosIns.get(url);
      return res;
    },

    ////// QR Code Functions
    async getQRCodesDDL({ commit }) {
      let url = `qr_code_ddl/`;      
      const res = await axiosIns.get(url);
      return res;
    },

    async createQRCode({ commit }, payload) {
      const res = await axiosIns.post("qr_code/", payload);
      return res;
    },


    ////// Evacuation Diagram Functions
    async getEvacuationDiagrams({ commit }, { pageNumber, site, building, expiry_date }) {
      let url = `evacuation_diagram/?page=${pageNumber}`;      
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building) {
        url += `&building=${building.id}`;
      }
      if (expiry_date) {
        url += `&expiry_date=${expiry_date}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getEvacuationDiagram({ commit }, { pk }) {
      const res = await axiosIns.get(`evacuation_diagram/${pk}/`);
      return res;
    },
    async createEvacuationDiagram({ commit }, payload) {
      const res = await axiosIns.post("evacuation_diagram/", payload);
      return res;
    },
    async updateEvacuationDiagram({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`evacuation_diagram/${pk}/`, payload);
      return res;
    },
    async deleteEvacuationDiagram({ commit }, { pk }) {
      const res = await axiosIns.delete(`evacuation_diagram/${pk}/`);
      return res;
    },


    ////// Flood Diagram Functions
    async getFloodDiagrams({ commit }, { pageNumber, site, building, expiry_date }) {
      let url = `flood_diagram/?page=${pageNumber}`;      
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building) {
        url += `&building=${building.id}`;
      }
      if (expiry_date) {
        url += `&expiry_date=${expiry_date}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getFloodDiagram({ commit }, { pk }) {
      const res = await axiosIns.get(`flood_diagram/${pk}/`);
      return res;
    },
    async createFloodDiagram({ commit }, payload) {
      const res = await axiosIns.post("flood_diagram/", payload);
      return res;
    },
    async updateFloodDiagram({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`flood_diagram/${pk}/`, payload);
      return res;
    },
    async deleteFloodDiagram({ commit }, { pk }) {
      const res = await axiosIns.delete(`flood_diagram/${pk}/`);
      return res;
    },


    ////// Emergency Contact List Functions
    async getEcls({ commit }, { pageNumber, site, building }) {
      let url = `ecl/?page=${pageNumber}`;            
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building) {
        url += `&building=${building.id}`;
      }      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getEcl({ commit }, { pk }) {
      const res = await axiosIns.get(`ecl/${pk}/`);
      return res;
    },
    async createEcl({ commit }, payload) {
      const res = await axiosIns.post("ecl/", payload);
      return res;
    },

    async updateEcl({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`ecl/${pk}/`, payload);
      return res;
    },
    
    async deleteEcl({ commit }, { pk }) {
      const res = await axiosIns.delete(`ecl/${pk}/`);
      return res;
    },


    ////// Assembly Area Functions
    async getAssemblyAreas({ commit }, { pageNumber, site, building, area_type }) {
      let url = `assembly_area/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }
      if (building) {
        url += `&building=${building.id}`;
      }      
      if (area_type) {
        url += `&area_type=${area_type.id}`;
      }      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getAssemblyArea({ commit }, { pk }) {
      const res = await axiosIns.get(`assembly_area/${pk}/`);
      return res;
    },
    async createAssemblyArea({ commit }, payload) {
      const res = await axiosIns.post("assembly_area/", payload);
      return res;
    },

    async updateAssemblyArea({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`assembly_area/${pk}/`, payload);
      return res;
    },
    
    async deleteAssemblyArea({ commit }, { pk }) {
      const res = await axiosIns.delete(`assembly_area/${pk}/`);
      return res;
    },


    ////// Emergency Scenario Drill Functions
    async getEmergencyScenarioDrills({ commit }, { pageNumber, site }) {
      let url = `esd/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }
        
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getEmergencyScenarioDrill({ commit }, { pk }) {
      const res = await axiosIns.get(`esd/${pk}/`);
      return res;
    },
    async createEmergencyScenarioDrill({ commit }, payload) {
      const res = await axiosIns.post("esd/", payload);
      return res;
    },

    async updateEmergencyScenarioDrill({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`esd/${pk}/`, payload);
      return res;
    },
    
    async deleteEmergencyScenarioDrill({ commit }, { pk }) {
      const res = await axiosIns.delete(`esd/${pk}/`);
      return res;
    },



     ////// Emergency Scenario Drill Functions
     async getEquipmentReports({ commit }, { pageNumber, site }) {
      let url = `equipment_report/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }
        
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getEquipmentReport({ commit }, { pk }) {
      const res = await axiosIns.get(`equipment_report/${pk}/`);
      return res;
    },
    async createEquipmentReport({ commit }, payload) {
      const res = await axiosIns.post("equipment_report/", payload);
      return res;
    },

    async updateEquipmentReport({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`equipment_report/${pk}/`, payload);
      return res;
    },
    
    async deleteEquipmentReport({ commit }, { pk }) {
      const res = await axiosIns.delete(`equipment_report/${pk}/`);
      return res;
    },


     ////// Device Functions
     async getDevices({ commit }, { pageNumber, name, site }) {
      let url = `device/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }
      if (name) {
        url += `&name=${name}`;
      }
        
      const res = await axiosIns.get(url);
      return res;
    },

    async getDevicesDDL({ commit }) {
      let url = `device_ddl/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    
    async getDevice({ commit }, { pk }) {
      const res = await axiosIns.get(`device/${pk}/`);
      return res;
    },
    async createDevice({ commit }, payload) {
      const res = await axiosIns.post("device/", payload);
      return res;
    },

    async updateDevice({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`device/${pk}/`, payload);
      return res;
    },
    
    async deleteDevice({ commit }, { pk }) {
      const res = await axiosIns.delete(`device/${pk}/`);
      return res;
    },


    ////// Fire Alarm Functions
    async getFireAlarms({ commit }, { pageNumber, site, alarm_type, building }) {
      let url = `fire_alarm/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }

      if (building) {
        url += `&building=${building.id}`;
      }

      if (alarm_type) {
        url += `&alarm_type=${alarm_type}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    
    
    async createFireAlarm({ commit }, payload) {
      const res = await axiosIns.post("fire_alarm/", payload);
      return res;
    },

    async updateFireAlarm({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`fire_alarm/${pk}/`, payload);
      return res;
    },
    
    async deleteFireAlarm({ commit }, { pk }) {
      const res = await axiosIns.delete(`fire_alarm/${pk}/`);
      return res;
    },


    async getEmergencyDrills({ commit }, { pageNumber, site, alarm_type, building }) {
      let url = `emergency_drill/?page=${pageNumber}`;                  
      if (site) {
        url += `&site=${site.id}`;
      }

      if (building) {
        url += `&building=${building.id}`;
      }

      if (alarm_type) {
        url += `&alarm_type=${alarm_type}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    
    
    async createEmergencyDrill({ commit }, payload) {
      const res = await axiosIns.post("emergency_drill/", payload);
      return res;
    },

    async updateEmergencyDrill({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`emergency_drill/${pk}/`, payload);
      return res;
    },
    
    async deleteEmergencyDrill({ commit }, { pk }) {
      const res = await axiosIns.delete(`emergency_drill/${pk}/`);
      return res;
    },



    ////// Notifications Functions
    async getNotifications({ commit }) {
      let url = `notification/`;                              
      const res = await axiosIns.get(url);
      return res;
    },
    
    async updateNotification({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`notification/${pk}/`, payload);
      return res;
    },    

    ////// Peeps Functions
    async getPeeps({ commit }, { pageNumber, peep_type, name, building, floor, assistance_type }) {
      let url = `peep/?page=${pageNumber}`;                  
      if (peep_type) {
        url += `&peep_type=${peep_type}`;
      }
      if (name) {
        url += `&name=${name}`;
      }
      if (building) {
        url += `&building=${building}`;
      }
      if (floor) {
        url += `&floor=${floor}`;
      }
      if (assistance_type) {
        url += `&assistance_type=${assistance_type}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },

    ////// Building Emergency State Functions
    async getBuildingEmergencyState({ commit }, { pageNumber, name, building, mobile_number, is_peep, in_building, reached_assembly_area }) {
      let url = `user_building/?page=${pageNumber}`;                  
      if (name) {
        url += `&name=${name}`;
      }
      if (building) {
        url += `&building=${building}`;
      }
      if (mobile_number) {
        url += `&mobile_number=${mobile_number}`;
      }
      if (is_peep !== undefined) {
        url += `&is_peep=${is_peep}`;
      }
      if (in_building !== undefined) {
        url += `&in_building=${in_building}`;
      }
      if (reached_assembly_area !== undefined) {
        url += `&reached_assembly_area=${reached_assembly_area}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },


    ////// Flood Emergency Functions
    async getFloodEmergency({ commit }, { pageNumber, building, status }) {
      let url = `flood_alarm/?page=${pageNumber}`;                  
      
      if (building) {
        url += `&building=${building}`;
      }
      if (status !== undefined) {
        url += `&status=${status}`;
      }
      
      const res = await axiosIns.get(url);
      return res;
    },



    ///// General Links
    async getCounter({ commit }) {
      const res = await axiosIns.get("counter");
      return res;
    },

    async getStates({ commit }) {
      const res = await axiosIns.get("state/");
      return res;
    },

    async getCitys({ commit }) {
      const res = await axiosIns.get("city/");
      return res;
    },

    async getSubStates({ commit }) {
      const res = await axiosIns.get("sub_state/");
      return res;
    },
    async changePassword({ commit }, { payload }) {
      const res = await axiosIns.post(`users/change-password/`, payload);
      return res;
    },
    async requestReset({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/request-reset/`, payload);
      return res;
    },
    async confirmReset({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/confirm-reset/`, payload);
      return res;
    },
    async checkResetCode({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/check-reset-code/`, payload);
      return res;
    },

    async getSubscriptionsToken({ commit }) {
      const res = await axiosIns.post(`email_token`);
      return res;
    },

    async createSubscription({ commit }) {
      const res = await axiosIns.post(`create_subscription`);
      return res;
    },

    async deleteSubscription({ commit }, payload) {
      const res = await axiosIns.post(`delete_subscription`, payload);
      return res;
    },

    async getFloodAlarm({ commit }, { pk }) {
      const res = await axiosIns.get(`flood_alarm_public/${pk}/`);
      return res;
    },

    async getBuildingFloorStatus({ commit }, { pk }) {
      const res = await axiosIns.get(`building_floor_stats/${pk}/`);
      return res;
    },

  },
};
